export const sessionGateTranslations = {
  lv: {
    noRolesTitle: 'Nav aktīvu lomu',
    noRoles:
      'Jums nav piešķirta neviena aktīva loma. Sazinieties ar organizācijas administratoru, lai saņemtu piekļuvi.',
  },
  en: {
    noRolesTitle: 'No active roles',
    noRoles:
      'You have no active roles assigned. Contact the organization administrator to get access.',
  },
} as const
